import React from 'react'
import MediaHero from './MediaHero'
import StoryInspriation from './StoryInspriation'
import ShiningMoment from './ShiningMoment'
import Watch from './Watch'
import Transforming from './Transforming'
const MediaPage = () => {
  return (
      <>
      <MediaHero />
      <StoryInspriation />
      <ShiningMoment />
      <Watch />
      <Transforming/>
      </>
  )
}

export default MediaPage